<style scoped>
.setting-smtp-block .save-btn {
    text-align: center;
    position: relative;
    margin:  10px auto;
}

.smtp-setting-block .open-smtp-setting-modal-btn-block {
    padding: 10px 0 0 0;
}
</style>

<template>
<div class="col-12 row clock-block input-setting-block smtp-setting-block">
    <div class="offset-2 col-1 elips"></div>
    <div class="col-6 item-name">
        Настройки почты - SMTP
    </div>
    <div class="col-3 open-smtp-setting-modal-btn-block">
        <a class="aquazor-btn-small open-smtp-setting-modal-btn" @click="showModal">Изменить</a>
    </div>
    <b-modal size="lg" ref="settingModal" hide-footer v-model="show_modal">
        <div class="setting-smtp-block text-center container-fluid">
            <h3>Настройки почты - SMTP</h3>
            <loader-component v-if="modal_loader" class="col-12 row"></loader-component>
            <div v-if="!modal_loader">
                <div class="col-12 row input-setting-block">
                    <div class="col-3 item-name">
                        Хост
                    </div>
                    <div class="col-9">
                        <input v-bind:class="{fail: msg_host}" v-model="host" type="text" autocomplete="off">
                    </div>
                </div>
                <div class="col-12 row input-setting-block">
                    <div class="col-3 item-name">
                        Логин
                    </div>
                    <div class="col-9">
                        <input v-bind:class="{fail: msg_login}" v-model="login" type="text" autocomplete="off">
                    </div>
                </div>
                <div class="col-12 row input-setting-block">
                    <div class="col-3 item-name">
                        Пароль
                    </div>
                    <div class="col-9">
                        <input style="display:none" autocomplete="off">
                        <input type="password" style="display:none" autocomplete="off">
                        <input v-bind:class="{fail: msg_password}" type="password" v-model="password" autocomplete="off">
                    </div>
                </div>
                <div class="col-12 row input-setting-block">
                    <div class="col-3 item-name">
                        E-mail отправителя
                    </div>
                    <div class="col-9">
                        <input v-bind:class="{fail: msg_from_email}" v-model="from_email" type="text" autocomplete="off">
                    </div>
                </div>
                <div class="col-12 row">
                    <a class="aquazor-btn save-btn" @click="saveSmtpSetting">Сохранить</a>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import loader from './loader.vue'

export default {
    data() {
        return {
            show_modal: false,
            modal_loader: true,
            host: null,
            msg_host: null,
            login: null,
            msg_login: null,
            password: null,
            msg_password: null,
            from_email: null,
            msg_from_email: null,
        }
    },
    methods: {
        showModal() {
            get_smtp_setting(this)
            this.$refs.settingModal.show()
        },
        hideModal() {
            this.$refs.settingModal.hide()
        },
        saveSmtpSetting() {
            save_smtp_setting(this)
        }
    },
    components: {
        'loader-component': loader
    },
    watch: {
        show_modal: function (show_modal_value) {
            console.log(show_modal_value)
            if (!show_modal_value) {
                this.modal_loader = true
            }
        }
    },
}

function save_smtp_setting(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('host', vue_obj.host)
        post_data.set('login', vue_obj.login)
        post_data.set('password', vue_obj.password)
        post_data.set('from_email', vue_obj.from_email)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor_settings/set_setting_smtp',
                data: post_data
            })
            .then(function (response) {
                console.log(response.data)
                vue_obj.hideModal()
            })
            .catch(function (error) {
                console.log(error.response.data)
            })
    }
}

function get_smtp_setting(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('setting_name', 'smtp')
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor_settings/get_setting',
                data: post_data
            })
            .then(function (response) {
                if (!!response.data.settings.host) {
                    vue_obj.host = response.data.settings.host
                }
                if (!!response.data.settings.login) {
                    vue_obj.login = response.data.settings.login
                }
                if (!!response.data.settings.password) {
                    vue_obj.password = response.data.settings.password
                }
                if (!!response.data.settings.from_email) {
                    vue_obj.from_email = response.data.settings.from_email
                }
            })
            .catch(function (error) {
                console.log(error.response.data)
            })
            .finally(function (request) {
                vue_obj.modal_loader = false
            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/smtp_settings.vue